import {Swiper} from 'swiper'
import {FreeMode} from 'swiper/modules'
import {breakpointDown} from '../utils/breakpoints'
import gsap from 'gsap'
import {ScrollTrigger} from 'gsap/ScrollTrigger'

gsap.registerPlugin(ScrollTrigger)


$('.js-vacancies-buttons-slider').each((i, el) => {
  // animate  when in screen
  let swiperLastEl = $(el).find('.swiper-slide').last()
  let swiperWrapper = $(el).find('.swiper-wrapper')
  let swiper = new Swiper(el, {
    slidesPerView: 'auto',
  });
  if ($(window).width() < 992) {

    ScrollTrigger.create({
      trigger: el,
      start: "top bottom", // el top, screen bottom
      once: true,
      onEnter: () => {
        $(el).find('.swiper-wrapper').delay(300).animate({left: '-80px'}, 600,
          function () {
            $(this).animate({left: 0}, 600)
          })
      }
    });
  }

  $(el).find('.swiper-slide').on('click', function() {
    let index = $(this).index(); // Get the index of clicked slide
    swiper.slideTo(index); // Scroll to the clicked slide
  });

})

window.onVacanciesFilter = (element ,value = null, meta_title='', meta_description = '') => {
  updateMeta(false, meta_title, meta_description, true)
  gsap.set('.vacancies-list', {opacity: 0})
  const newUrl = new URL(window.location.href);
  if(value) {
    newUrl.searchParams.set('category', value);
  } else {
    newUrl.searchParams.delete('category');
  }
  newUrl.searchParams.delete('vacancy');
  window.history.pushState({}, '', newUrl);
  $('.js-vacancies-buttons-slider .swiper-wrapper .c-btn').removeClass('active');
  element.classList.add('active');
  oc.ajax('onVacanciesCategoryFilter', {
    update: {
      'vacancies/list': true
    }
  })
  addEventListener('ajax:update-complete', function (event) {
    if (event.detail.context.handler === 'onVacanciesCategoryFilter') {
      gsap.to('.vacancies-list', {opacity: 1, duration: 0.4});
      window.initImageWithTextSlider();
    }
  });
}
